var libreria = 0;
jQuery(".getscript").click(function(e2) {
    e2.preventDefault();
    const loaded = $(this).data("loaded");
    var id_video = jQuery(this).attr("data-id");
    loaded == !1 || loaded == null ? ($(this).data("loaded", "true"),
    jQuery.getScript("https://fast.wistia.com/assets/external/E-v1.js", function(data2, textStatus, jqxhr) {
        jQuery.getScript("https://fast.wistia.com/embed/medias/" + id_video + ".jsonp", function(data3, textStatus2, jqxhr2) {
            window.wistiaInit = function(W) {
                W.api(id_video).play()
            }
            ,
            libreria = 1
        })
    })) : jQuery.getScript("https://fast.wistia.com/embed/medias/" + id_video + ".jsonp", function(data2, textStatus, jqxhr) {
        window.wistiaInit = function(W) {
            W.api(id_video).play()
        }
    }),
    console.log(id_video),
    console.log(libreria)
});

$(document).on('click', '.video-yt', function() {
  var tipo=$(this).attr('data-url');
  $("#myModaly").fadeIn();
  $(".video_y").attr('src',tipo+'?controls=1&showinfo=0&autoplay=1&rel=0');
  
});

$(".close").click(function(){
  $(".video_y").attr('src',"");
  $("#myModaly").fadeOut();
});

$("#myModaly").click(function(event){
  if (!$(event.target).closest(".modal-content-y").length) {
    $(".video_y").attr('src', ""); // Detener video
    $("#myModaly").fadeOut();
  }
});

$(".show-more-industry").click(function (e){
  e.preventDefault();
  const span=$(this).find('span');
  const text = span.text() === 'Mostrar menos productos' ? 'Mostrar más productos' : 'Mostrar menos productos';
  const cat=$(this).data('category');
  $("."+cat).toggleClass('d-none');
  $(this).find('span').text(text);
  $(this).toggleClass('active');
});

$(document).ready(function() {
  margenIndex();
});

$(window).on('load', function() {
  margenIndex();
});

$(window).resize(function(){
  margenIndex();
});

function margenIndex() {
  var margen = parseInt($('.container--large').css('margin-right'));
  
  console.log(margen);

  $('.bg-banner').css({ 'margin-left': 0 });
  if( $('.bg-banner').get(0)){
    $('.bg-banner').get(0).style.setProperty('--margen-negativo', -margen + 'px');
  }
}
/*
$(document).ready(function() {
  // Esperar un momento para asegurar que los filtros de Shopify estén cargados
  setTimeout(function() {
    const $slider = $('#weight-slider');
    const $minInput = $('#slider-min');
    const $maxInput = $('#slider-max');
    
    if ($slider.length > 0) {
      // Asegurarse de que noUiSlider esté cargado
      if (typeof noUiSlider !== 'undefined') {
        noUiSlider.create($slider[0], {
          start: [0, 2000], // Valores iniciales
          connect: true,    // Conecta los handles con una barra coloreada
          step: 1,          // Incremento
          range: {
            'min': 0,
            'max': 2000
          },
          format: {
            to: value => parseInt(value),
            from: value => parseInt(value)
          }
        });
        
        // Inicializar con los valores de los checkboxes ya marcados
        function initializeSliderFromCheckboxes() {
          const $weightCheckboxes = $('.weight-filter');
          let minVal = 2000;
          let maxVal = 0;
          
          $weightCheckboxes.each(function() {
            if ($(this).prop('checked')) {
              const value = parseFloat($(this).val());
              minVal = Math.min(minVal, value);
              maxVal = Math.max(maxVal, value);
            }
          });
          
          // Solo actualizar si encontramos valores marcados
          if (maxVal >= minVal) {
            $slider[0].noUiSlider.set([minVal, maxVal]);
          }
        }
        
        // Ejecutar una vez al inicio
        initializeSliderFromCheckboxes();
        
        // Actualizar los inputs y checkboxes cuando cambia el slider
        $slider[0].noUiSlider.on('update', function(values) {
          const min = values[0];
          const max = values[1];
        
          // Actualizar valores de input
          $minInput.val(min);
          $maxInput.val(max);
        
          // Obtener todos los checkboxes del filtro de peso
          const $weightCheckboxes = $('.weight-filter');
          
          // Recorrer cada checkbox y marcar/desmarcar según los valores del slider
          $weightCheckboxes.each(function() {
            const value = parseFloat($(this).val());
            const shouldBeChecked = value >= min && value <= max;
            
            // Solo disparar cambio si el estado es diferente
            if ($(this).prop('checked') !== shouldBeChecked) {
              $(this).prop('checked', shouldBeChecked);
              
              // Disparar eventos para asegurar que el sistema de filtros de Shopify se actualice
              $(this).trigger('change');
              $(this).trigger('input');
              
              // Buscar el formulario padre y disparar input en él también
              const $parentForm = $(this).closest('form');
              if ($parentForm.length && $parentForm.attr('id') === 'FacetFiltersForm') {
                $parentForm.trigger('input');
              }
            }
          });
        });
        
        // Escuchar cambios en los campos de entrada
        $minInput.on('change', function() {
          $slider[0].noUiSlider.set([$(this).val(), null]);
        });
        
        $maxInput.on('change', function() {
          $slider[0].noUiSlider.set([null, $(this).val()]);
        });
      } else {
        console.error('La biblioteca noUiSlider no está cargada. Por favor, asegúrate de incluirla.');
      }
    }
  }, 300); // Pequeño retraso para asegurar que los filtros estén cargados
});

*/

/*const SLIDER_MAX = 500;
let usuarioInteractuo = false;

function setupPesoRange(container) {
  const pesoMinInput = container.querySelector('.peso-min-input');
  const pesoMaxInput = container.querySelector('.peso-max-input');
  const minValDisplay = container.querySelector('.peso-min-value');
  const maxValDisplay = container.querySelector('.peso-max-value');
  const pesoMinSlider = container.querySelector('.slider-min');
  const pesoMaxSlider = container.querySelector('.slider-max');
  const thumbMin = container.querySelector('.thumb-min');
  const thumbMax = container.querySelector('.thumb-max');
  const rangeBar = container.querySelector('.range-bar');

  function actualizarSliderVisual() {
    const min = parseInt(pesoMinInput.value) || 0;
    const max = parseInt(pesoMaxInput.value) || SLIDER_MAX;

    const percentMin = (min / SLIDER_MAX) * 100;
    const percentMax = (max / SLIDER_MAX) * 100;

    thumbMin.style.left = `calc(${percentMin}% + 8px)`;
    thumbMax.style.left = `calc(${percentMax}% - 8px)`;
    rangeBar.style.left = `${percentMin}%`;
    rangeBar.style.width = `${percentMax - percentMin}%`;

    minValDisplay.textContent = min;
    maxValDisplay.textContent = max;

    pesoMinSlider.value = min;
    pesoMaxSlider.value = max;
  }

  function actualizarCheckboxesPeso() {
    if (!usuarioInteractuo) return;

    const min = parseInt(pesoMinInput.value);
    const max = parseInt(pesoMaxInput.value);

    const checkboxes = document.querySelectorAll('input[name="filter.p.m.custom.peso"]');
    let hayCheckboxesSeleccionados = false;

    checkboxes.forEach((checkbox) => {
      const peso = parseInt(checkbox.value);
      const estabaMarcado = checkbox.checked;
      checkbox.checked = peso >= min && peso <= max;

      if (checkbox.checked) {
        hayCheckboxesSeleccionados = true;
      }

      if (checkbox.checked !== estabaMarcado) {
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    setTimeout(() => {
      const contenedor = document.getElementById('main-collection-product-grid');
      const checkboxesActivos = document.querySelectorAll('input[name="filter.p.m.custom.peso"]:checked');

      if (!hayCheckboxesSeleccionados && checkboxesActivos.length === 0) {
        contenedor.innerHTML = `
          <p class="no-content-message rte">
            No se encontró ningún producto<br>
            Usa menos filtros o <a class="button--text" href="?q=&amp;options%5Bprefix%5D=last&amp;sort_by=created-descending">borra todo</a>
          </p>
        `;
      }
    }, 1500);
  }

  function guardarValores() {
    const min = parseInt(pesoMinInput.value) || 0;
    const max = parseInt(pesoMaxInput.value) || SLIDER_MAX;
    localStorage.setItem('pesoMin', min);
    localStorage.setItem('pesoMax', max);
  }

  function cargarValores() {
    const checkboxesActivos = document.querySelectorAll('input[name="filter.p.m.custom.peso"]:checked');
    const min = localStorage.getItem('pesoMin');
    const max = localStorage.getItem('pesoMax');

    if (checkboxesActivos.length > 0 && min && max) {
      pesoMinInput.value = min;
      pesoMaxInput.value = max;
      pesoMinSlider.value = min;
      pesoMaxSlider.value = max;
    }
  }

  function onChangeInputs(min, max) {
    pesoMinInput.value = min;
    pesoMaxInput.value = max;
    pesoMinSlider.value = min;
    pesoMaxSlider.value = max;
    actualizarSliderVisual();
    actualizarCheckboxesPeso();
    guardarValores();
  }

  pesoMinInput.addEventListener('input', () => {
    usuarioInteractuo = true;
    let min = parseInt(pesoMinInput.value) || 0;
    let max = parseInt(pesoMaxInput.value) || SLIDER_MAX;
    min = Math.min(min, max - 1);
    onChangeInputs(min, max);
  });

  pesoMaxInput.addEventListener('input', () => {
    usuarioInteractuo = true;
    let min = parseInt(pesoMinInput.value) || 0;
    let max = parseInt(pesoMaxInput.value) || SLIDER_MAX;
    max = Math.max(max, min + 1);
    onChangeInputs(min, max);
  });

  pesoMinSlider.addEventListener('input', () => {
    usuarioInteractuo = true;
    let min = parseInt(pesoMinSlider.value);
    let max = parseInt(pesoMaxSlider.value);
    if (min >= max) min = max - 1;
    onChangeInputs(min, max);
  });

  pesoMaxSlider.addEventListener('input', () => {
    usuarioInteractuo = true;
    let min = parseInt(pesoMinSlider.value);
    let max = parseInt(pesoMaxSlider.value);
    if (max <= min) max = min + 1;
    onChangeInputs(min, max);
  });

  function setupThumbDragging(thumb, isMin) {
    let active = false;

    const onPointerStart = (e) => {
      e.preventDefault();
      active = true;
      usuarioInteractuo = true;
    };

    const onPointerMove = (e) => {
      if (!active) return;

      const rect = rangeBar.parentElement.getBoundingClientRect();
      let percent = ((e.clientX - rect.left) / rect.width) * 100;
      percent = Math.max(0, Math.min(100, percent));
      const value = Math.round((percent / 100) * SLIDER_MAX);

      let min = parseInt(pesoMinInput.value);
      let max = parseInt(pesoMaxInput.value);

      if (isMin) {
        min = Math.min(value, max - 1);
      } else {
        max = Math.max(value, min + 1);
      }

      if (isMin) {
        pesoMinSlider.value = min;
      } else {
        pesoMaxSlider.value = max;
      }

      pesoMinSlider.dispatchEvent(new Event('input', { bubbles: true }));
      pesoMaxSlider.dispatchEvent(new Event('input', { bubbles: true }));

      onChangeInputs(min, max);
    };

    const onPointerEnd = () => (active = false);

    thumb.addEventListener('pointerdown', onPointerStart);
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerEnd);
  }

  setupThumbDragging(thumbMin, true);
  setupThumbDragging(thumbMax, false);

  // Agregado: guardar al cambiar un checkbox manualmente
  const checkboxes = document.querySelectorAll('input[name="filter.p.m.custom.peso"]');
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      guardarValores();
    });
  });

  cargarValores();
  actualizarSliderVisual();
}

// Inicializar todos los bloques .peso-range
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.peso-range').forEach(setupPesoRange);
});*/